import React, { useEffect, useState } from "react";
import "./styles.scss";
import "./mobile.scss";
import { Button, JobCard, NewsGroup, TopMenu } from "../../components";
import Menu from "../templates/menu";
import { setTheme } from "../../utils/themes";
import HotNewsSmall from "../templates/hotNewsSmall";
import Footer from "../footer/index";
import { getLanguage } from "../../utils/environment";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { useDispatch, useSelector } from "react-redux";
import { GetIconByName } from "../../config/icon";
import { openHomeAdModal, openMobileMenuModal } from "../console/redux/actions";
import { AdvertisementModal, MobileMenuModal, HomeAdViewModal } from "../modal";
import { Helmet } from "react-helmet";
import {
  ConsoleTopLeftAdd,
  ConsoleTopRightAdd,
  HomePageCenterAdd,
  NewsViewLeftBottomAdd,
  NewsViewRightTopAdd,
} from "../templates/advertiesments";
import {
  getAllJobs,
  getAllJobsCategory,
} from "../CreateNewItem/CreateNewJob/service/jobs.service";
import { setJobCategoryList, setJobList, setJobs } from "../Jobs/redux/actions";
import { getCookie, setCookie } from "../../utils/cookie";
import moment from "moment";

const lan = getLanguage();

const Index = (props) => {
  const [category, setCategory] = React.useState("");
  const [news, setNews] = React.useState("");
  const [jobCategory, setJobCategory] = useState([]);
  const [isSticky, setIsSticky] = useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [visibleCount, setVisibleCount] = useState(10);

  const dispatch = useDispatch();
  const { isOpenMobileMenuModal, isOpenAd } = useSelector(
    ({ consoleReducer }) => consoleReducer
  );
  const [isOpenAdvertisementModal, setIsOpenAdvertisementModal] =
    useState(false);
  const { jobCategoryList, jobList } = useSelector(
    ({ jobsReducer }) => jobsReducer
  );

  useEffect(() => {
    setTheme("light");

    // async function userInsight() {
    //   try {
    //     let param = window.location.pathname.split("/");

    //     if (param.length > 2) {
    //       const newsId = param[2];
    //       const categoryId = param[3];
    //       // Fetch existing insight if it exists
    //       await handleInsight(newsId, categoryId);
    //     }
    //   } catch (error) {
    //     console.error("Error in userInsight:", error);
    //   }
    // }
    // userInsight();
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY >= 20);
      console.log(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const getList = await getAllJobs();
        console.log("Get All Jobs : ", getList);

        if (getList.data) {
          dispatch(setJobList(getList.data));
        } else {
          console.log("Data Not Found");
        }
      } catch (error) {
        console.log("Error fetching Data", error);
      }
    };
    setIsOpenAdvertisementModal(false);
    fetchData();

    // Check if cookie already exists
    // const promoCookie = getCookie("popup");

    // if (!promoCookie) {
    //   // No cookie => show modal + set cookie
    //   // dispatch(openHomeAdModal());

    //   // Set cookie that expires in 1 day (24h)
    //   setCookie("popup", "POPUP_ADVERTISEMENT", { days: 1 });
    // }
    setIsOpenAdvertisementModal(true);
  }, []);

  const fetchCategories = async () => {
    const response = await getAllJobsCategory();
    if (response?.data) {
      setJobCategory(response.data);
      dispatch(setJobCategoryList(response.data));
    }
  };

  const fetchTagName = (id) => {
    const isExist = (jobCategoryList || jobCategory)?.find(
      (x) => x?.job_category_id === id
    );
    console.log({ isExist });
    return isExist?.jobs_category_name;
  };

  useEffect(() => {
    if (jobCategoryList?.length === 0) {
      fetchCategories();
    }
  }, []);

  const handleChildData = (childData) => {
    // props.onChangeCategory(childData); // Update state with child data
    setCategory(childData);
  };

  return (
    <>
      {/* {isOpenAd && <HomeAdViewModal />} */}
      {isOpenAdvertisementModal && <AdvertisementModal />}

      <Helmet>
        <title>{news?.title?.[lan] || "News today"}</title>
        <meta
          name="description"
          content={
            news?.summary?.[lan]?.slice(0, 150) ||
            "Latest news updates from Hope of a New Era."
          }
        />
        <meta property="og:title" content={news?.title?.[lan]} />
        <meta
          property="og:description"
          content={news?.summary?.[lan]?.slice(0, 150)}
        />
        <meta property="og:image" content={news?.images?.[0]?.url} />
        <meta property="og:url" content={window.location.href} />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={window.location.href} />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "NewsArticle",
            headline: news?.title?.[lan],
            image: [news?.images?.[0]?.url],
            datePublished: news?.created_at,
            dateModified: news?.updated_at || news?.created_at,
            author: {
              "@type": "Organization",
              name: "Hope of a New Era",
            },
            publisher: {
              "@type": "Hope of a New Era",
              name: "Hope of a New Era",
              logo: {
                "@type": "ImageObject",
                url: "https://example.com/logo.png",
              },
            },
          })}
        </script>
      </Helmet>
      <>
        {isOpenMobileMenuModal && <MobileMenuModal />}
        <div className={`cw__top-menu ${isSticky ? "sticky" : ""}`}>
          <TopMenu
            data={{
              size: "lg",
              isLanguage: true,
              isLogo: false,
              isProfile: false,
            }}
            onClickPublish={() => {
              props.history.push("/admin");
            }}
          />
        </div>
        <div className={"container"}>
          <div className={`cw__tab ${isSticky ? "sticky" : ""} `}>
            <div className={"cwt__hope"}>
              <img
                src={require("../../assets/img/lgo (1).png")}
                alt={news?.title?.[lan]}
              />
            </div>
            <div className={"menu"}>
              <Menu setMenuName={handleChildData} />
            </div>

            {/* <div
              className={"cwt__menu-mobile"}
              onClick={() => {
                dispatch(openMobileMenuModal());
              }}
            >
              {GetIconByName("menu")}
            </div> */}
          </div>
          <div className={"cw__advertiesment-wrapper"}>
            <ConsoleTopLeftAdd />
            <ConsoleTopRightAdd />
          </div>
          <div className={`gov-jobs-wrapper`}>
            <div className={"gj__special-news-group"}>
              <NewsGroup
                data={{
                  titleName: "All Jobs",
                  // linkName: "තවත් පුවත්",
                  // linkName: (
                  //   <>
                  //     {pageCount > news?.length && (
                  //       <div
                  //         className={
                  //           "d-flex flex-column justify-content-center align-items-center mt-5"
                  //         }
                  //       >
                  //         <Pagination
                  //           data={{
                  //             paginationCount: pageCount,
                  //             pageNo: pageNo,
                  //           }}
                  //           onChange={onChangePage}
                  //         />
                  //       </div>
                  //     )}
                  //   </>
                  // ),
                }}
                // onClickViewNews={() => {
                //   onChangePage(pageNo + 1);
                // }}
              >
                <div id="container-12e03264376f1867506e14bf4ff8a092"></div>

                <div className="pl-3 pr-3">
                  {Array.isArray(jobList) && jobList.length > 0 ? (
                    [...jobList]
                      .sort(
                        (a, b) =>
                          new Date(b.created_at) - new Date(a.created_at)
                      )
                      .sort((a, b) => {
                        const now = moment();
                        const aExpired = now.isAfter(moment(a?.closing_date));
                        const bExpired = now.isAfter(moment(b?.closing_date));

                        // Active first (false < true)
                        if (aExpired === bExpired) return 0;
                        return aExpired ? 1 : -1;
                      })
                      .slice(0, visibleCount)
                      .map((jobs) => (
                        <JobCard
                          key={jobs?.job_id}
                          data={{
                            // imgUrl:
                            //   jobs?.banner_img?.file_url || jobs?.banner_img,
                            titleEn: jobs?.job_title?.en,
                            titleSi: jobs?.job_title?.si,
                            closingDate: jobs?.closing_date,
                            organization:
                              fetchTagName(jobs?.organization) || "",
                            type: jobs?.job_application_type,
                            views: jobs?.views || 0,
                            downloads: jobs?.downloads || 0,
                            isArrow: true,
                          }}
                          // isOpen={activeCard === jobs?.job_id}
                          onClickView={() => {
                            // setSelectJobs(jobs?.job_id);
                            // setActiveCard(jobs?.job_id);
                            dispatch(setJobs(jobs));
                            // props.history.push("/gov-jobs/gov-job-view");
                            if (jobs?.keywords) {
                              props.history.push(
                                `/jobs/${jobs?.keywords}/${jobs?.job_id}`
                              );
                            } else {
                              const generatedSlug = jobs.job_title?.["si"]
                                ?.replace(/[\u200B-\u200D\uFEFF]/g, "")
                                ?.replace(/\s*-\s*/g, " ")
                                ?.replace(/\s*–\s*/g, " ")
                                ?.trim()
                                .split(/\s+/)
                                .slice(0, 5)
                                .join("-")
                                .replace(/-+/g, "-");
                              props.history.push(
                                `/jobs/${generatedSlug}/${jobs?.job_id}`
                              );
                            }
                          }}
                        />
                      ))
                  ) : (
                    <div className="error-message">No Jobs Found</div>
                  )}

                  {/* Fade-out effect (only when collapsed) */}
                  {jobList.length > 10 && visibleCount < jobList.length && (
                    <div
                      style={{
                        height: "50px",
                        background:
                          "linear-gradient(to bottom, rgba(255,255,255,0), white)",
                        marginTop: "-50px",
                        zIndex: 1,
                      }}
                    />
                  )}

                  {/* Show More / Show Less Button */}
                  {jobList.length > 10 && (
                    <div
                      className="loading-more"
                      style={{ marginTop: "5px", marginBottom: "20px" }}
                    >
                      <Button
                        data={{
                          btnName:
                            visibleCount >= jobList.length
                              ? "Show Less"
                              : "Show More..",
                          buttonType: "black-border",
                          buttonSize: "xs",
                          isLoading: isLoading,
                          btnIcon: GetIconByName(
                            visibleCount >= jobList.length
                              ? "arrow-up"
                              : "arrow-down"
                          ),
                        }}
                        onClick={() => {
                          setVisibleCount((prev) => {
                            if (prev >= jobList.length) {
                              // Reset to first 4 and scroll to top smoothly
                              window.scrollTo({ top: 0, behavior: "smooth" });
                              return 10;
                            }
                            return Math.min(prev + 10, jobList.length);
                          });
                        }}
                      />
                    </div>
                  )}
                </div>
              </NewsGroup>

              {/* <NewsGroup
                data={{
                  titleName: "Related Jobs",
                  linkName: "තවත් පුවත්",
                  // linkName: (
                  //   <>
                  //     {pageCount > news?.length && (
                  //       <div
                  //         className={
                  //           "d-flex flex-column justify-content-center align-items-center mt-5"
                  //         }
                  //       >
                  //         <Pagination
                  //           data={{
                  //             paginationCount: pageCount,
                  //             pageNo: pageNo,
                  //           }}
                  //           onChange={onChangePage}
                  //         />
                  //       </div>
                  //     )}
                  //   </>
                  // ),
                }}
                // onClickViewNews={() => {
                //   onChangePage(pageNo + 1);
                // }}
              >
                <JobCard />
                <div>
                  {Array.isArray(jobList) && jobList.length > 0 ? (
                    jobList.map((jobs) => (
                      <JobCard
                        data={{
                          imgUrl: jobs?.banner_img,
                          titleEn: jobs?.job_title?.en,
                          titleSi: jobs?.job_title?.si,
                          closingDate: jobs?.closing_date,
                          organization: jobs?.organization,
                          type: jobs?.job_application_type,
                        }}
                        isOpen={activeCard === jobs?.job_id}
                        onClickView={() => {
                          props.history.push("/gov-jobs/gov-job-view");
                          // setActiveCard(jobs?.job_id);
                        }}
                      />
                    ))
                  ) : (
                    <div className="error-message">No Jobs Found</div>
                  )}
                </div>
              </NewsGroup> */}

              <div className="bottom-ad">
                <NewsViewLeftBottomAdd />
              </div>
              <div className="bottom-ad-mobile">
                <HomePageCenterAdd />
              </div>
            </div>
            <div className={"gj__special-news-group"}>
              <NewsViewRightTopAdd data={{ mainLayerStyles: "mb-3" }} />
              <HotNewsSmall setMenuName={handleChildData} />
            </div>
          </div>
        </div>
        <Footer />
      </>
    </>
  );
};

export default withRouter(Index);
